import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const CancelInvoiceDialog = ({ invoice, open, onOpenChange, onDone, kind = "invoice" }) => {
  const isBill = kind === "bill";
  const number = isBill ? invoice?.bill_number : invoice?.invoice_number;
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api.post(isBill ? `/purchase/bills/${invoice.id}/cancel` : `/sales/invoices/${invoice.id}/cancel`, { reason });
      toast.success(`${isBill ? "Bill" : "Invoice"} cancelled · ledger reversed${r.data.stock_lines_restored ? ` · ${r.data.stock_lines_restored} stock line(s) adjusted` : ""}`);
      setReason(""); onOpenChange(false); onDone?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Cancel failed"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-sm sm:max-w-md" data-testid="cancel-invoice-dialog">
        <DialogHeader><DialogTitle className="font-heading">Cancel {isBill ? "bill" : "invoice"} {number}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">
          {isBill
            ? "This reverses the purchase ledger entry (and ITC), takes the received goods back out of stock and removes the bill from GSTR-3B ITC / IMS. The bill stays on record marked CANCELLED. This cannot be undone."
            : "This reverses the sales and COGS ledger entries, puts goods back into stock and removes the invoice from GSTR-1 / 3B. The invoice stays on record marked CANCELLED. This cannot be undone."}
        </p>
        <div><Label>Reason *</Label>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} placeholder={isBill ? "e.g. Duplicate bill / wrong vendor" : "e.g. Raised on wrong customer"} className="rounded-sm mt-1 min-h-[70px]" data-testid="cancel-invoice-reason" />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Keep {isBill ? "bill" : "invoice"}</Button>
          <Button onClick={go} disabled={busy || reason.trim().length < 5} className="rounded-sm bg-red-600 hover:bg-red-700 text-white" data-testid="cancel-invoice-confirm">{busy ? "Cancelling…" : `Cancel ${isBill ? "bill" : "invoice"}`}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
